'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedAmountInput } from '@/components/trade/animated-amount-input';
import { TradeDetails } from '@/components/trade/trade-details';
import { AnimatedButton } from '@/components/ui/animated-button';
import { DetailWalletPicker } from '@/components/wallet/detail-wallet-picker';
export function StakeSummaryRow(t0) {
  const $ = _c(9);
  const {
    formattedTotal
  } = t0;
  const t = useTranslations("launchpad.detail");
  let t1;
  if ($[0] !== t) {
    t1 = t("yourStake");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-body text-foreground-secondary">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== formattedTotal) {
    t3 = <span className="text-body font-medium tabular-nums text-foreground-primary">{formattedTotal}</span>;
    $[4] = formattedTotal;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex items-center justify-between rounded-panel-inset border bg-background-secondary px-3 py-2">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
interface FundTabProps {
  amountInput: string;
  onAmountInputChange: (next: string) => void;
  currencySymbol: string;
  formattedBalance: string;
  formattedQuickAmounts: {
    label: string;
    value: number;
  }[];
  onQuickAmount: (amount: number) => void;
  onMaxClick: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  inputDisabled: boolean;
  exceedsBalance: boolean;
  isValidFundAmount: boolean;
  fundSubmitDisabled: boolean;
  formattedNetStake: string;
  formattedBackingFee: string;
  formattedTotalCost: string;
}
export function FundTab(props) {
  const $ = _c(48);
  const {
    amountInput,
    onAmountInputChange,
    currencySymbol,
    formattedBalance,
    formattedQuickAmounts,
    onQuickAmount,
    onMaxClick,
    onSubmit,
    isSubmitting,
    inputDisabled,
    exceedsBalance,
    isValidFundAmount,
    fundSubmitDisabled,
    formattedNetStake,
    formattedBackingFee,
    formattedTotalCost
  } = props;
  const tBack = useTranslations("launchpad.back");
  const tFees = useTranslations("launchpad.fees");
  let t0;
  if ($[0] !== tBack) {
    t0 = tBack("balanceLabel");
    $[0] = tBack;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== exceedsBalance) {
    t1 = exceedsBalance ? {
      valueClassName: "text-feedback-error-content"
    } : {};
    $[2] = exceedsBalance;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== formattedBalance || $[5] !== isSubmitting || $[6] !== t0 || $[7] !== t1) {
    t2 = <DetailWalletPicker balanceLabel={formattedBalance} fallbackLabel={t0} disabled={isSubmitting} {...t1} />;
    $[4] = formattedBalance;
    $[5] = isSubmitting;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = fundSubmitDisabled ? undefined : onSubmit;
  let t4;
  if ($[9] !== tBack) {
    t4 = tBack("amountLabel");
    $[9] = tBack;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== tBack) {
    t5 = tBack("maxButton");
    $[11] = tBack;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== amountInput || $[14] !== currencySymbol || $[15] !== formattedQuickAmounts || $[16] !== inputDisabled || $[17] !== onAmountInputChange || $[18] !== onMaxClick || $[19] !== onQuickAmount || $[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <AnimatedAmountInput value={amountInput} onChange={onAmountInputChange} currencySymbol={currencySymbol} quickAmounts={formattedQuickAmounts} onQuickAmount={onQuickAmount} onMaxClick={onMaxClick} onSubmit={t3} disabled={inputDisabled} inputLabel={t4} maxLabel={t5} />;
    $[13] = amountInput;
    $[14] = currencySymbol;
    $[15] = formattedQuickAmounts;
    $[16] = inputDisabled;
    $[17] = onAmountInputChange;
    $[18] = onMaxClick;
    $[19] = onQuickAmount;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const t7 = !isValidFundAmount;
  let t8;
  if ($[24] !== tFees) {
    t8 = tFees("netStake");
    $[24] = tFees;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== formattedNetStake || $[27] !== t8) {
    t9 = {
      label: t8,
      value: formattedNetStake
    };
    $[26] = formattedNetStake;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== tFees) {
    t10 = tFees("backingFee");
    $[29] = tFees;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== formattedBackingFee || $[32] !== t10) {
    t11 = {
      label: t10,
      value: formattedBackingFee
    };
    $[31] = formattedBackingFee;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t9) {
    t12 = [t9, t11];
    $[34] = t11;
    $[35] = t9;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== tFees) {
    t13 = tFees("totalCost");
    $[37] = tFees;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== formattedTotalCost || $[40] !== t12 || $[41] !== t13 || $[42] !== t7) {
    t14 = <TradeDetails feeKind="proposal-fund" feesRowHidden={t7} items={t12} totalLabel={t13} totalValue={formattedTotalCost} />;
    $[39] = formattedTotalCost;
    $[40] = t12;
    $[41] = t13;
    $[42] = t7;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t14 || $[45] !== t2 || $[46] !== t6) {
    t15 = <>{t2}{t6}{t14}</>;
    $[44] = t14;
    $[45] = t2;
    $[46] = t6;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  return t15;
}
export function FundSubmitButton(t0) {
  const $ = _c(5);
  const {
    disabled,
    loading,
    onSubmit,
    label
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== label || $[2] !== loading || $[3] !== onSubmit) {
    t1 = <AnimatedButton size="xl" disableHoverScale={true} disableTapScale={true} className="w-full border border-transparent text-body-lg font-semibold" disabled={disabled} loading={loading} onClick={onSubmit}>{label}</AnimatedButton>;
    $[0] = disabled;
    $[1] = label;
    $[2] = loading;
    $[3] = onSubmit;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
interface WithdrawTabProps {
  canWithdraw: boolean;
  withdrawSubmitDisabled: boolean;
  withdrawSubmitLoading: boolean;
  withdrawSubmitLabel: string;
  formattedUnbackingFee: string;
  formattedNetReturn: string;
  onSubmit: () => void;
}
export function WithdrawTab(props) {
  const $ = _c(14);
  const {
    canWithdraw,
    withdrawSubmitDisabled,
    withdrawSubmitLoading,
    withdrawSubmitLabel,
    formattedUnbackingFee,
    formattedNetReturn,
    onSubmit
  } = props;
  const t = useTranslations("launchpad.detail");
  const tFees = useTranslations("launchpad.fees");
  let t0;
  if ($[0] !== canWithdraw || $[1] !== formattedNetReturn || $[2] !== formattedUnbackingFee || $[3] !== t || $[4] !== tFees) {
    t0 = canWithdraw ? <TradeDetails feeKind="proposal-withdraw" feesRowHidden={false} items={[{
      label: tFees("unbackingFee"),
      value: formattedUnbackingFee,
      isNegative: true
    }]} totalLabel={tFees("netReturn")} totalValue={formattedNetReturn} /> : <p className="py-4 text-center text-body text-foreground-secondary">{t("noBackingYet")}</p>;
    $[0] = canWithdraw;
    $[1] = formattedNetReturn;
    $[2] = formattedUnbackingFee;
    $[3] = t;
    $[4] = tFees;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== onSubmit || $[7] !== withdrawSubmitDisabled || $[8] !== withdrawSubmitLabel || $[9] !== withdrawSubmitLoading) {
    t1 = <AnimatedButton size="xl" disableHoverScale={true} disableTapScale={true} className="w-full border border-transparent text-body-lg font-semibold" disabled={withdrawSubmitDisabled} loading={withdrawSubmitLoading} onClick={onSubmit}>{withdrawSubmitLabel}</AnimatedButton>;
    $[6] = onSubmit;
    $[7] = withdrawSubmitDisabled;
    $[8] = withdrawSubmitLabel;
    $[9] = withdrawSubmitLoading;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== t0 || $[12] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}